import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import { userService } from "../../../services/CommonServices";
import ReactPaginate from "react-paginate";
import Loader from "../../Loader/Loader";

const BookingsList = () => {
  let navigate = useNavigate();
  const globalData = useContext(GlobalContext);

  const [res, setRes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [providers, setProviders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const itemsPerPage = 10;

  useEffect(() => {
    // Fetch initial data for dropdowns and table
    get_providers_and_customers();
    get_customers_list(0);
  }, []);

  function get_providers_and_customers() {
    const headers = {
      Authorization: globalData.token,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    userService.get_providers_ids_and_names_api(headers).then(response => {
        if (response.status === 200) {
            setProviders(response.data.data);
        }
    });

    userService.get_customers_ids_and_names_api(headers).then(response => {
        if (response.status === 200) {
            setCustomers(response.data.data);
        }
    });
  }

  function get_customers_list(page) {
    const headers = {
      Authorization: globalData.token,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    const params = {
      page,
      size: itemsPerPage,
      provider: selectedProvider,
      customer: selectedCustomer,
      status: selectedStatus,
      bookingDate,
    };

    userService
      .bookings_list_api(headers, params)
      .then((response) => {
        if (response.status === 200) {
          setRes(response.data.data);
          setTotalPages(Math.ceil(response.data.total / itemsPerPage));
          setIsLoading(false);
        }
      })
      .catch((error) => {
        alert(error);
        setIsLoading(false);
        if (error.response?.status === 401) {
          globalData.set_token("");
          globalData.set_org_id("");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("org_id");
          navigate("/login");
        }
      });
  }

  const handleSearchApply = () => {
    setIsLoading(true);
    get_customers_list(0); // Fetch data with applied filters
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setIsLoading(true);
    get_customers_list(selectedPage);
  };

  return (
    <div className="content_area">
      <div>{isLoading && <Loader />}</div>
      <div className="tables_area">
        <div className="title-box">
          <h2 className="pull-left">Bookings List</h2>
          <div className="clear"></div>
        </div>
        <div className="filter-box">
          <select
            value={selectedProvider}
            onChange={(e) => setSelectedProvider(e.target.value)}
          >
            <option value="">Select Provider</option>
            {providers.map((provider) => (
              <option key={provider.id} value={provider.id}>
                {provider.name}
              </option>
            ))}
          </select>
          <select
            value={selectedCustomer}
            onChange={(e) => setSelectedCustomer(e.target.value)}
          >
            <option value="">Select Customer</option>
            {customers.map((customer) => (
              <option key={customer.id} value={customer.id}>
                {customer.name}
              </option>
            ))}
          </select>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="">Select Status</option>
            <option value="2">Accepted</option>
            <option value="5">Job started</option>
            <option value="6">Job ended</option>
          </select>
          <input
            type="date"
            value={bookingDate}
            onChange={(e) => setBookingDate(e.target.value)}
          />
          <button onClick={handleSearchApply}>Search Apply</button>
        </div>
        <div className="white_box">
          <div className="table-responsive">
            <table width="100%" cellSpacing="0" cellPadding="0">
              <thead>
                <tr>
                  <th>id</th>
                  <th>User</th>
                  <th>Provider</th>
                  <th>Service</th>
                  <th>Price</th>
                  <th>Start time</th>
                  <th>End time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {res.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.user.firstName} {item.user.lastName}</td>
                    <td>{item.providerService.provider.firstName} {item.providerService.provider.lastName}</td>
                    <td>{item.providerService.defaultService ? item.providerService.defaultService.name : item.providerService.additionalNotes}</td>
                    <td>{item.price}</td>
                    <td>{item.startTime}</td>
                    <td>{item.endTime}</td>
                    <td>
                      {item.status === 1
                        ? "Pending"
                        : item.status === 2
                        ? "Accepted"
                        : item.status === 3
                        ? "Cancelled by user"
                        : item.status === 4
                        ? "Cancelled by provider"
                        : item.status === 5
                        ? "Job started"
                        : item.status === 6
                        ? "Job ended"
                        : item.status === 8
                        ? "Cancelled by system due to idle"
                        : "Unknown"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={totalPages}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
          />
        </div>
      </div>
    </div>
  );
};

export default BookingsList;